import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { EstablishmentService } from '../establishment/establishment.service';
import { Establishment } from 'app/models/establishment';

@Injectable({
  providedIn: 'root'
})
export class MenuService implements Resolve<any> {

  establishment: Establishment;

  constructor(
    private _establishmentService: EstablishmentService
  ) { }

   /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
   resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
   {
           return new Promise((resolve, reject) => {
               Promise.all([
                   this.getEstablishment(),
               ]).then(
                   () => {
                       resolve({});
                   },
                   () => {
                       console.error("Erreur home resolve");
                       reject();
                   }
               );
           });
   }
   
   /**
    * Get partner
    *
    * @returns {Promise<any>}
    */
   getEstablishment(): Promise<any>
   {
       return new Promise((resolve, reject) => {
           this._establishmentService.establishment$
               .subscribe((response: any) => {
                       this.establishment = response;
                       resolve({});
               }, () => {
                   console.error("Erreur getEstablishment");
                   reject();
               });
       });
   } 
    
}
